import $ from 'jquery'

export default {
    name: 'assurance-groupe-list',
    components: {},
    props: [],
    data() {
        return {
            groupe_assur: '',
            groupe_assur_id: 0,
            grp_loading: true,
            grp_is_empty: false,
            groupe_to_be_deleted: [],

            grp_fields: ['groupes', { key: 'default', label: 'Base' }, 'actif', 'actions'],
            grp_per_page: 5,
            is_list_group: true,
            filter: "",
			perPage: 10,
			currentPage: 1,

            g_default: '',
            g_actif: '',

            save_loading: false,
			btn_disable: false,

            del_loading: false,
            is_confirm: false,
        }
    },

    watch: {
		g_default() {
			this.changeDefaultBase('default', this.g_default)
		},

		g_actif() {
			this.changeDefaultBase('actif', this.g_actif)
		}
	},

    computed: {
        groupe_assurs() {
            return this.$store.getters["groupe_assurs"];
        },

		grp_rows() {
            return this.groupe_assurs.length;
        },
    },
    mounted() {
        // Liste des groupes d'assurances
		this.getGroupeAssurance()
    },
    methods: {
        changeDefaultBase(type_config, groupe_id) {
			let data = {
				type_config: type_config,
				groupe_id: groupe_id
			}

			this.$store.dispatch('configBaseActifAssurance', data)
		},
        
        getGroupeAssurance() {
			this.grp_loading = true
			this.$store.dispatch("getGroupeAssurance").then(() => {
				this.grp_loading = false
				if(this.groupe_assurs.length > 0) {
					this.grp_is_empty = false

					this
				} else {
					this.grp_is_empty = true
				}
			});
		},

        /**
		 * Ajouter un groupe d'assurance
		 */
		async submitGroupe() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

			let data = {
				groupe_assur_id: this.groupe_assur_id,
				groupe_assur: this.groupe_assur
			}

			this.$store.dispatch('addGroupeAssurance', data).then((response) => {
				if (response.saved_id > 0) {
					// $('.modal').modal('hide')
					this.getGroupeAssurance()
					
					
					this.groupe_assur = ''
					this.$refs.observer.reset();
                    $('.modal').modal('hide')
                    this.successMsg('Groupe d\'assurance ajouté avec succès')
				} else {
					if (response.is_exist > 0) {
						$('.err-msg-1').fadeIn(500)
					}
				}
				this.save_loading = false
				this.btn_disable = false
			})
		}, 

		editGroupe(data) {
			this.groupe_assur = data.groupe
			this.groupe_assur_id = data.groupe_id
		}, 

		removeGroupe(data) {
			this.groupe_to_be_deleted = {
                id: data.groupe_id,
                libelle: data.groupe,
            }
		},

		supprimerGroupe() {
			this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-grp');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteGroupeAssurance', this.groupe_to_be_deleted).then((response) => {
                    if (response > 0) {
                        // this.successMsg('Groupe d\'assurance supprimé avec succès')
                    }

					this.getGroupeAssurance();
					$('.delete-grp').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                    
                })
            }
		},

        /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },


    }
}


